import React from 'react';
import Fade from 'react-reveal/Fade';
import Breadcrumb from 'elements/Breadcrumb';

export default function PageDetailTitle({ data, breadcrumb }) {
  return (
    <section className="container spacing-sm" style={{ marginTop: "100px" }}>
      <Fade bottom>
        <div className="row align-items-center text-center text-md-start">
          {/* Breadcrumb di atas */}
          <div className="col-12 mb-3">
            <Breadcrumb data={breadcrumb} />
          </div>

          {/* Judul dan lokasi */}
          <div className="col-12">
            <h1 className="h2">{data.title}</h1>
            <span className="text-gray-400">
              {data.city}, {data.country}
            </span>
          </div>
        </div>
      </Fade>
    </section>
  );
}
